import React from "react";
import Text from "@commons/Typography/Text";
import { type LegendItem } from "@typings/components/map";

interface MapFooterProps {
  legends: LegendItem[];
  className?: string;
  children?: React.ReactNode;
}

function MapFooter({ legends }: MapFooterProps) {
  return (
    <div className={"p-2 pb-0 flex flex-wrap gap-4 lg:gap-6"}>
      {legends.map((legend, index) => (
        <div key={index} className="flex items-center space-x-2">
          <span
            className={`inline-block w-3 h-3 rounded-full ${legend.color}`}
          />

          <Text size="sm">{legend.label}</Text>
        </div>
      ))}
    </div>
  );
}

export default MapFooter;
